export default "__VITE_ASSET__BsVTRuhq__"